import { useLocation } from 'react-router-dom';
import { AdminAuthCallback } from './AdminAuthCallback';
import { AdminDashboard } from './AdminDashboard';
import { AdminLogin } from './AdminLogin';
import { useAdminAuth } from '../hooks/useAdminAuth';

const AdminAccess = () => {
  const { user, loading, error, startLogin, signOut } = useAdminAuth();
  if (loading) {
    return <main className="min-h-screen bg-slate-950 text-slate-500 flex items-center justify-center" data-testid="admin-session-loading">Checking administrator access…</main>;
  }
  if (!user) return <AdminLogin error={error} onLogin={startLogin} />;
  return <AdminDashboard user={user} onSignOut={signOut} />;
};

export default function AdminPanel() {
  const location = useLocation();
  const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
  if (sessionId) return <AdminAuthCallback sessionId={sessionId} />;
  return <AdminAccess />;
}
